import gql from 'graphql-tag';

export const fixCheckupAppointmentOrganization = gql`
  mutation fixCheckupAppointmentOrganization($input: CheckupAppointmentOrganizationFixInput!) {
    fixCheckupAppointmentOrganization(input: $input) {
      id
    }
  }
`;
